import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(props.width || 264)}
    height={301}
    fill="none"
    {...props}
  >
    <path stroke={`url(#${props.newid||"ama"})`} strokeWidth={2} d="m1 1.138 261.499 298.441" />
    <defs>
      <linearGradient
        id={(props.newid||"ama")}
        x1={58.109}
        x2={226.878}
        y1={-21.011}
        y2={414.218}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.5} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
